import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import {
  Container, Icon, Loader, Button,
} from '../../ui-kit';
import './styles.scss';
import { Gallery } from '..';
import { getBeautyDateString } from '../../services/datetime';
import languages from '../../constants/languages';
import musicGenres from '../../constants/music-genres';

const Offer = (props) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [locationOpen, setLocationOpen] = useState(false);

  const renderCurrency = () => {
    if (props.currency === 'euro') {
      return '€';
    }

    if (props.currency === 'dollar') {
      return '$';
    }

    if (props.currency === 'aed') {
      return 'AED';
    }
  };

  const renderDueDate = () => {
    if (props.dueDate === 'perMonth') {
      return 'every month';
    }

    if (props.dueDate === 'perWeek') {
      return 'every week';
    }
  };

  const renderInfoBadge = (value, arr, textCase = 'lower') => (
    <div className="offer_item">
      <span>
        {value}
        :
      </span>
      <span className={`offer_${textCase}_case`}>
        {arr.map((item, i) => (`${item.label}${arr.length !== i + 1 ? ', ' : ''} `))}
      </span>
    </div>
  );

  const wrapperRef = useRef(null);

  const useOutsideAlerter = (ref, func) => {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
          func(false);
        }
      };

      // Bind the event listener
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener('mousedown', handleClickOutside);
      };
      // eslint-disable-next-line
    }, [ref]);
  };

  useOutsideAlerter(wrapperRef, setMenuOpen);
  useOutsideAlerter(wrapperRef, setLocationOpen);

  return (
    <Container className="offer__block">
      <div className="offer_container">
        <div className="offer_actions__container">
          <div
            style={{
              backgroundImage: `url(${props.image})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            }}
            className="offer_logo__container"
          >
            {typeof props.location === 'object' && (
              <button
                ref={wrapperRef}
                className="offer_location"
                title="Casting location"
                onClick={() => setLocationOpen(!locationOpen)}
              >
                <div
                  ref={wrapperRef}
                  className="offer_location_name"
                  style={locationOpen ? { display: 'block' } : {}}
                >
                  <span>
                    {`${
                      props.location.country || props.location.ru?.country
                    }, ${props.location.city || props.location.ru?.city}`}
                  </span>
                </div>
                <div
                  ref={wrapperRef}
                  className="triangle"
                  style={locationOpen ? { display: 'block' } : {}}
                >
                  <Icon name="triangle" />
                </div>
                <Icon name="geo" width="1.125em" height="1.125em" />
              </button>
            )}
            <div className="offer_price">
              {props.payment}
              {renderCurrency()}
              {' '}
              {renderDueDate()}
              <br />
              {props.type}
            </div>
            {props.creatorId && (
              <div
                className="offer_creator_link"
                title={`Full data about creator (${props.creatorId})`}
              >
                <a
                  href={`/user#${props.creatorId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Icon name="user" />
                </a>
              </div>
            )}
          </div>
          {props.views ? (
            <div>
              <div className="offer_views">
                <Icon name="eye" />
                <span>{props.views}</span>
              </div>
              <div className="offer_feedbacks">
                <Icon name="chat" />
                <span>{props.feedbacks}</span>
              </div>
            </div>
          ) : null}
          {!props.actionsDisabled && props.status && (
            <button
              ref={wrapperRef}
              className="offer_status"
              onClick={() => setMenuOpen(!menuOpen)}
            >
              {!props.dropDownLoader ? (
                <>
                  <span>{props.status}</span>
                  <Icon name="arrow-down" />
                  <div
                    ref={wrapperRef}
                    className="offer_checked_status__block"
                    style={menuOpen ? { display: 'block' } : {}}
                  >
                    <Icon name="triangle" />
                    {props.status !== 'accept' && props.status !== 'archive' && (
                      <button
                        value="accept"
                        onClick={() => props.acceptCasting(props.id)}
                      >
                        Accept
                      </button>
                    )}
                    {props.status !== 'decline' && props.status !== 'archive' && (
                      <button
                        value="decline"
                        onClick={() => props.declineCasting(props.id)}
                      >
                        Decline
                      </button>
                    )}
                    {props.status !== 'archive' && props.status !== 'moderated' && (
                      <button
                        value="archive"
                        onClick={() => props.handleActionsConfirmOpen(props.id, props.name, 'archive')}
                      >
                        Archive
                      </button>
                    )}
                    {props.status === 'archive' && (
                      <button
                        value="archive"
                        onClick={() => props.handleActionsConfirmOpen(props.id, props.name, 'unarchive')}
                      >
                        Unarchive
                      </button>
                    )}
                  </div>
                </>
              ) : (
                <Loader />
              )}
            </button>
          )}
        </div>
        <div className="offer_basic">
          <div className={`offer_content__container${!props.actionsDisabled ? ' with-actions' : ''}`}>
            <span className="offer__title">Casting name</span>
            <div className="offer_content__block">
              <span className="offer_name">{props.name}</span>
            </div>
            <span className="offer__title">Publication date</span>
            <div className="offer_content__block">
              <span className="offer_desctiption_container">
                {getBeautyDateString(new Date(props.createdTime))}
              </span>
            </div>
            <span className="offer__title">Casting description</span>
            <div className="offer_content__block">
              <span className="offer_desctiption_container">
                {props.description}
              </span>
            </div>
            <span className="offer__title">Requirements</span>
            <div className="offer_require__block">
              {props.requirements.height && (
                <div className="offer_item">
                  Height:
                  {' '}
                  {props.requirements.height}
                  cm
                </div>
              )}
              {props.requirements.weight && (
                <div className="offer_item">
                  Weight:
                  {' '}
                  {props.requirements.weight}
                  kg
                </div>
              )}
              {props.requirements.breast && (
                <div className="offer_item">
                  Breast size:
                  {' '}
                  {props.requirements.breast}
                </div>
              )}
              {props.requirements.waist && (
                <div className="offer_item">
                  Waist:
                  {' '}
                  {props.requirements.waist}
                  cm
                </div>
              )}
              {props.requirements.thigh && (
                <div className="offer_item">
                  Thigh:
                  {' '}
                  {props.requirements.waist}
                  cm
                </div>
              )}
              {props.age && (
                <div className="offer_item">
                  {props.age === 'no-matter'
                    ? 'Age does not matter'
                    : `Age: ${props.age}`}
                </div>
              )}
              {props.gender && (
                <div className="offer_item">
                  Gender:
                  {props.gender}
                </div>
              )}
              {props.requirements.languages
                && props.requirements.languages.map((item) => (
                  <div className="offer_item offer_dropdown_item">
                    <span>{item.customName ? item.customName : languages[item.id]}</span>
                    <div className="offer_dropdown__block">
                      <Icon name="info" />
                    </div>
                    {item.levels.length > 0 && (
                      <div className="offer_dropdown__container">
                        <Icon name="triangle" />
                        {item.levels.map((e) => (
                          <span>{e}</span>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              {props.requirements.hairСolor
                && renderInfoBadge('Hair color', props.requirements.hairСolor)}
              {props.requirements.genre
                && renderInfoBadge('Genres', props.requirements.genre.map((el) => ({...el, label: musicGenres[el.value]})))}
              {props.requirements.appearanceType
                && renderInfoBadge(
                  'Appearance type',
                  props.requirements.appearanceType,
                )}
              {props.requirements.shoeSize
                && renderInfoBadge('Shoe size', props.requirements.shoeSize)}
              {props.requirements.clothingSize
                && renderInfoBadge(
                  'Clothing size',
                  props.requirements.clothingSize,
                  'upper',
                )}
              {props.requirements.noTatoo && (
                <div className="offer_item">Without tattoo</div>
              )}
              {props.requirements.video && (
                <div className="offer_item">Video presentation required</div>
              )}
              {props.requirements.videoPortfolio && (
                <div className="offer_item">Video portfolio required</div>
              )}
              {props.requirements.gaitVideo && (
                <div className="offer_item">Сatwalk is required</div>
              )}
              {props.requirements.promo && (
                <div className="offer_item">Promo required</div>
              )}
              {props.requirements.photosPortfolio && (
                <div className="offer_item">Photos portfolio required</div>
              )}
              {props.requirements.photos && (
                <div className="offer_item">Photo required</div>
              )}
            </div>
            {props.sphere && (
              <>
                <span className="offer__title">Sphere</span>
                <div className="offer_sphere__block">
                  <div className="offer_item">{props.sphere.enName}</div>
                </div>
              </>
            )}
            {props.category && (
              <>
                <span className="offer__title">Сategories</span>
                <div className="offer_сategories__block">
                  <div className="offer_item">{props.category.enName}</div>
                </div>
              </>
            )}
            {!props.actionsDisabled && (
              <div className="offer_buttons">
                <Button
                  value="Edit"
                  onClick={() => props.handleModalOpen(props.id, props.name, props.description)}
                />
                <Button
                  value="Delete"
                  onClick={() => props.handleActionsConfirmOpen(props.id, props.name, 'delete')}
                  type="secondary"
                />
              </div>
            )}
          </div>
        </div>
        <div className="offer_separator" />
        <div className="offer_gallery_container">
          <span className="offer__title">Photos</span>
          {props.photos.length > 0 && (
            <Gallery
              castingId={props.id}
              photos={props.photos}
              handleConfirmOpen={props.handleDeletePhotoConfirmOpen}
            />
          )}
          {props.photos.length === 0 && (
            <div className="offer_not_photos">
              <Icon name="camera" width="3em" height="3em" />
              <p className="offer_not_photos_text">No photos</p>
            </div>
          )}
        </div>
      </div>
      {props.date && <span className="offer_date">{props.date}</span>}
    </Container>
  );
};

Offer.propTypes = {
  location: PropTypes.string,
  payment: PropTypes.number,
  views: PropTypes.number,
  status: PropTypes.string.isRequired,
  name: PropTypes.string,
  description: PropTypes.string,
  requirements: PropTypes.array,
  sphere: PropTypes.array,
  category: PropTypes.array,
  image: PropTypes.string,
  date: PropTypes.string,
  id: PropTypes.string,
  dropDownLoader: PropTypes.bool,
  acceptCasting: PropTypes.func,
  declineCasting: PropTypes.func,
  age: PropTypes.string,
  currency: PropTypes.string,
  dueDate: PropTypes.string,
  type: PropTypes.string,
  photos: PropTypes.array,
  feedbacks: PropTypes.number,
  actionsDisabled: PropTypes.bool,
  creatorId: PropTypes.string,
  gender: PropTypes.string,
  handleDeletePhotoConfirmOpen: PropTypes.func,
  handleModalOpen: PropTypes.func,
  handleActionsConfirmOpen: PropTypes.func,
  createdTime: PropTypes.object,
};
Offer.defaultProps = {
  location: '',
  payment: null,
  description: '',
  views: null,
  name: '',
  requirements: [],
  sphere: [],
  category: {},
  image: '',
  date: '',
  acceptCasting: () => {},
  declineCasting: () => {},
  id: '',
  dropDownLoader: false,
  age: null,
  currency: null,
  dueDate: null,
  type: '',
  photos: [],
  feedbacks: null,
  actionsDisabled: false,
  creatorId: '',
  gender: null,
  handleDeletePhotoConfirmOpen: () => {},
  handleModalOpen: () => {},
  handleActionsConfirmOpen: () => {},
  createdTime: null,
};

export default Offer;
